import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import TinderCard from "react-tinder-card";
import SwipeIndicatorStrip from "./subcomponents/swipeIndicatorStrip";
import SubGameTip from "./subGameTip";

function Swipe({ missionData, setShowSwipe, setShowSubgameTip, showSubgameTip, isMissionEnd }) {
  const { t, i18n } = useTranslation();
  const [correctAnswers, setCorrectAnswers] = useState(0);
  const [swipedCards, setSwipedCards] = useState(0);
  const [showFinish, setShowFinish] = useState(false);

  const card1 = useRef();
  const card2 = useRef();
  const card3 = useRef();

  let titleRef = useRef(null);
  let cardContainerRef = useRef(null);
  let helpRef = useRef(null);
  let lionRef = useRef(null);

  const [animation, setAnimation] = useState(null);

  useEffect(() => {
    if (missionData) {
      if (missionData.swipe_finished) {
        //setShowSwipe(false);
        setShowSubgameTip(true);
      }
    }
  }, [missionData]);

  useEffect(() => {
    let timer;
    if (swipedCards === 3) {
      setShowFinish(true);
      if (correctAnswers === 3) {
        timer = setTimeout(() => {
          setShowSubgameTip(true);
        }, 2000);
      }
      return () => {
        clearTimeout(timer);
      }
    }
  }, [correctAnswers, swipedCards]);

  const handleSwipe = (direction, item) => {
    const answer = direction === 'right' ? 1 : 0;
    if (item === 'card_1') {
      setSwipedCards(swipedCards + 1);
      if (missionData.swipe.card_1_answer === answer) {
        setCorrectAnswers(correctAnswers + 1);
      }
    } else if (item === 'card_2') {
      setSwipedCards(swipedCards + 1);
      if (missionData.swipe.card_2_answer === answer) {
        setCorrectAnswers(correctAnswers + 1);
      }
    } else if (item === 'card_3') {
      setTimeout(() => {
        setSwipedCards(swipedCards + 1);
      }, 1500);
      if (missionData.swipe.card_3_answer === answer) {
        setTimeout(() => {
          setCorrectAnswers(correctAnswers + 1);
        }, 1500);

      }
    }
  }

  const handleThmbsClick = async (ref, type, item) => {
    const answer = type === 'right' ? 1 : 0;
    if (item === 'card_1') {
      setSwipedCards(swipedCards + 1);
      if (missionData.swipe.card_1_answer === answer) {
        setCorrectAnswers(correctAnswers + 1);
      }
    } else if (item === 'card_2') {
      setSwipedCards(swipedCards + 1);
      if (missionData.swipe.card_2_answer === answer) {
        setCorrectAnswers(correctAnswers + 1);
      }
    } else if (item === 'card_3') {
      setTimeout(() => {
        setSwipedCards(swipedCards + 1);
      }, 1500);
      if (missionData.swipe.card_3_answer === answer) {
        setTimeout(() => {
          setCorrectAnswers(correctAnswers + 1);
        }, 1500);

      }
    }
    await ref.swipe(type);
  }

  const getCardTitle = (card) => {
    if (i18n.language === 'en') {
      return missionData.swipe[card + '_title_en'];
    } else {
      return missionData.swipe[card + '_title_nl'];
    }
  }

  const getCardHint = (card) => {
    if (i18n.language === 'en') {
      return missionData.swipe[card + '_hint_en'];
    } else {
      return missionData.swipe[card + '_hint_nl'];
    }
  }

  const restartGame = () => {
    setCorrectAnswers(0);
    setSwipedCards(0);
    setShowFinish(false);
  }

  return (
    <div className={`swipe-wrapper ${isMissionEnd ? 'missionEnded' : ''}`}>
      <div className="swipe">
        <div className="card-container" ref={e => cardContainerRef = e}>
          <div></div>
          {swipedCards < 3 &&
            <div className="card-wrapper">
              {missionData && missionData.swipe && (
                <>
                  <TinderCard
                    preventSwipe={["up", "down"]}
                    swipeRequirementType={'position'}
                    onSwipe={e => { handleSwipe(e, 'card_3') }}
                    ref={card3}
                    className="swipe-card"
                  >
                    <div className={`card-inner ${swipedCards === 2 ? 'active' : 'not-active'} level-${3 - swipedCards}`}>
                      <div className="image">
                        <img src={missionData.swipe.card_3_image} />
                      </div>
                      <div className="card card-3">
                        <div className="text">
                          <p>
                            {getCardTitle('card_3')}
                          </p>
                        </div>
                        <div className="icon-wrapper">
                          <div className="swipe-button-container thumbs-down">
                            <div className="swipe-button" onClick={e => { e.stopPropagation(); handleThmbsClick(card3.current, 'left', 'card_3') }}></div>
                          </div>
                          <div className="swipe-button-container thumbs-up">
                            <div className="swipe-button" onClick={e => { e.stopPropagation(); handleThmbsClick(card3.current, 'right', 'card_3') }}></div>
                          </div>
                        </div>
                      </div>
                      <div className="swipeIndicatorStripContainer">
                        <SwipeIndicatorStrip />
                      </div>
                    </div>
                  </TinderCard>
                  <TinderCard
                    preventSwipe={["up", "down"]}
                    swipeRequirementType={'position'}
                    onSwipe={e => { handleSwipe(e, 'card_2') }}
                    ref={card2}
                    className="swipe-card"
                  >
                    <div className={`card-inner ${swipedCards === 1 ? 'active' : 'not-active'} level-${2 - swipedCards}`}>
                      <div className="image">
                        <img src={missionData.swipe.card_2_image} />
                      </div>
                      <div className="card card-2">
                        <div className="text">
                          <p>
                            {getCardTitle('card_2')}
                          </p>
                        </div>
                        <div className="icon-wrapper">
                          <div className="swipe-button-container thumbs-down">
                            <div className="swipe-button" onClick={e => { e.stopPropagation(); handleThmbsClick(card2.current, 'left', 'card_2') }}></div>
                          </div>
                          <div className="swipe-button-container thumbs-up">
                            <div className="swipe-button" onClick={e => { e.stopPropagation(); handleThmbsClick(card2.current, 'right', 'card_2') }}></div>
                          </div>
                        </div>
                      </div>
                      <div className="swipeIndicatorStripContainer">
                        <SwipeIndicatorStrip />
                      </div>
                    </div>
                  </TinderCard>
                  <TinderCard
                    preventSwipe={["up", "down"]}
                    swipeRequirementType={'position'}
                    onSwipe={e => { handleSwipe(e, 'card_1') }}
                    ref={card1}
                    className="swipe-card"
                  >
                    <div className={`card-inner ${swipedCards === 0 ? 'active' : 'not-active'} level-${1 - swipedCards}`}>
                      <div className="image">
                        <img src={missionData.swipe.card_1_image} />
                      </div>
                      <div className="card card-1">
                        <div className="text">
                          <p>
                            {getCardTitle('card_1')}
                          </p>
                        </div>
                        <div className="icon-wrapper">
                          <div className="swipe-button-container thumbs-down">
                            <div className="swipe-button" onClick={e => { e.stopPropagation(); handleThmbsClick(card1.current, 'left', 'card_1') }}></div>
                          </div>
                          <div className="swipe-button-container thumbs-up">
                            <div className="swipe-button" onClick={e => { e.stopPropagation(); handleThmbsClick(card1.current, 'right', 'card_1') }}></div>
                          </div>
                        </div>
                      </div>
                      <div className="swipeIndicatorStripContainer">
                        <SwipeIndicatorStrip />
                      </div>
                    </div>
                  </TinderCard>
                </>
              )}
            </div>
          }
        </div>
        {swipedCards < 3 &&
          <div className={`minigame-help frameSimple darkTheme animateIn`} ref={e => { helpRef = e }}>
            <h2>Goed of fout?</h2>
            <p className="bigger">Swipe links of rechts. Kijk in het boek voor hints.{/*getCardHint(`card_${swipedCards + 1}`)*/}</p>
          </div>
        }
        <div className="finish-wrapper">
          {showFinish &&
            <div className={`finish speechBalloonVertical ${correctAnswers === 3 ? 'auto-hide' : ''}`}>
              {correctAnswers !== 3 &&
                <>
                  <h3>{t("student.swipe.failed_title")}</h3>
                  <p>{t("student.swipe.failed_message", [correctAnswers, swipedCards])}</p>
                  <div className="restart-button-wrapper">
                    <div className="restart-button" onClick={restartGame}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" fill="none">
                        <path
                          fill="#E55816"
                          d="M48.344 3.883v14.906c0 1.863-1.553 3.312-3.313 3.312H30.125c-1.863 0-3.313-1.449-3.313-3.312 0-1.76 1.45-3.313 3.313-3.313h6.522a16.724 16.724 0 00-13.25-6.521c-9.11 0-16.46 7.35-16.46 16.459 0 9.213 7.35 16.562 16.46 16.562 3.623 0 7.039-1.138 9.937-3.312 1.45-1.035 3.52-.725 4.658.724 1.139 1.45.828 3.52-.62 4.659-4.038 3.002-8.903 4.554-13.976 4.554C10.665 48.601.313 38.25.313 25.414.313 12.68 10.665 2.33 23.396 2.33c7.247 0 13.872 3.312 18.323 8.902v-7.35c0-1.76 1.449-3.312 3.312-3.312 1.76 0 3.313 1.553 3.313 3.313z"
                        ></path>
                      </svg>
                      <span className="text">opnieuw</span>
                    </div>
                  </div>
                </>
              }
              {correctAnswers === 3 &&
                <>
                  <h3>{t("student.swipe.success_title")}</h3>
                  <p>{t("student.swipe.success_message", [correctAnswers, swipedCards])}</p>
                </>
              }
            </div>
          }
        </div>
      </div>
      <div className={`hint-background ${showSubgameTip ? 'unlocked' : ''}`}>
        {showSubgameTip && <div className="tip-container">
          <SubGameTip missionData={missionData} setShowSubgameTip={setShowSubgameTip} />
        </div>}
        <div className="panel-wrapper panel-top">
          <div className="background-panel"><div className="lock-band top"></div></div>
        </div>
        <div className="panel-wrapper panel-bottom">
          <div className="background-panel"><div className="lock-band bottom"></div></div>
        </div>
        <div className="lock-container">
          <div className={`lock ${showSubgameTip ? 'unlocked' : ''}`}></div>
        </div>
      </div>
    </div>
  );
}

export default Swipe;
